import { StoreModule } from '@ngrx/store';
import { UsersFeatureKey } from './users-feature-key';
import { usersReducer } from './users.reducer';

export * from './users-feature-key';
export * from './users.actions';
export * from './users.effects';
export * from './users.reducer';
export * from './users.selectors';

export const UsersStoreModule = StoreModule.forFeature(
  UsersFeatureKey,
  usersReducer
);
